import { render, staticRenderFns } from "./FrontpageHeader.vue?vue&type=template&id=67e613b4&"
import script from "./FrontpageHeader.vue?vue&type=script&lang=js&"
export * from "./FrontpageHeader.vue?vue&type=script&lang=js&"
import style0 from "./FrontpageHeader.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports